/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { Column, Container, Row } from '../../../styles/Grid';

import DotComponent from '../../ui/DotComponent';
import * as Styles from './index.style';
import Spacer from '../../ui/Spacer';
import { SafePureComponent } from '../../../utils/SafePureComponent';

class StepsStarted extends SafePureComponent {
  getGrid = (number, title, desc) => {
    return (
      <div>
        <h2>{number}</h2>
        <h3>{title}</h3>
        <span></span>
        <p>{desc}</p>
      </div>
    );
  };
  safeRender() {
    return (
      <Spacer customCss={Styles.containerSizesTop}>
        <Container>
          <div css={Styles.CommonCss}>
            {this.getGrid(
              1,
              'Download the app',
              'Get the Regus app for iOS or Android',
            )}
            {this.getGrid(
              2,
              'Register now',
              'Register your membership with your email address',
            )}
            {this.getGrid(
              3,
              'Work your way',
              'Manage your Regus account wherever you are',
            )}
          </div>
        </Container>
      </Spacer>
    );
  }
}

export default StepsStarted;
